/** Unique ID generator for template elements */
export const uid = (prefix = "el") => `${prefix}_${crypto.randomUUID()}`;

/** Layout constants matching the 612x792 canvas */
export const MARGIN_X = 36;
export const TOP_Y = 34;
export const CONTENT_W = 540; // PAGE_W - MARGIN_X*2
export const FONT_STACK = "Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif";

/**
 * SVG data URI for the logo placeholder.
 * Renders a subtle "Your Logo" graphic with dashed border.
 */
export const LOGO_PLACEHOLDER_DATA_URI = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" width="140" height="48" viewBox="0 0 140 48">
    <rect x="1" y="1" width="138" height="46" rx="8" fill="#f1f5f9" stroke="#cbd5e1" stroke-width="1.5" stroke-dasharray="4 3"/>
    <path d="M40 28l8-10 6 7 4-4 8 7" fill="none" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <circle cx="44" cy="20" r="2.5" fill="#94a3b8"/>
    <text x="78" y="27" font-family="Inter, system-ui, sans-serif" font-size="11" font-weight="600" fill="#94a3b8" text-anchor="middle">Your Logo</text>
  </svg>`
)}`;
